import { localizedMedia, localizedLink } from '../i18n/resources';
import { t } from '../i18n';
import {React, useEffect, useState, useRef} from "react";
import Navbar from "./Navbar";
import Package from "./Package";
import Footer from "./Footer";
import { Parallax } from 'react-parallax';
import InnerModal from "./InnerModal";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import plBgimgOriginal from "../img/Program_zmiana.jpg";
import plimgOriginal from "../img/soft99_program_lojalnosciowy_thumb_01.webp";

const plBgimg = localizedMedia(plBgimgOriginal, "Program_zmiana.jpg");
const plimg = localizedMedia(plimgOriginal, "soft99_program_lojalnosciowy_thumb_01.webp");


const Loyalty = (props) => {
    const myRef = useRef(null)
  const {service, services} = props;
  let pricePart = <span>{t("od x zł")}</span>;
  const executeScroll = () => myRef.current.scrollIntoView();
  let resBut = <button className="nav-res-service" onClick={executeScroll}>{t("Zarejestruj się")}</button>;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, []);

  function IframeLoad() {
    console.log('iframe load');
    let myiFrame = document.getElementById("myiFrame");
    console.log(myiFrame);
  }

  const [open, setOpen] = useState(false);
  const baseImgUrl = "https://test.cms.soft99.eu";
  const parallaxBgImg = plBgimg;
  let mediaBox = 
      <div className="service-media-part">
        <div className="service-media-part-single">
          <img src={plimg} alt=""></img>
        </div>
      </div>

  return(
        <section>
          <Modal open={open} onClose={() => setOpen(false)} center>
            <InnerModal setOpen={setOpen} service={service && service}/>
          </Modal>
          <header>
            <Navbar services={services} service={service} />
          </header>
          <Parallax bgImage={parallaxBgImg} strength={500} bgClassName="parallax-bg-services">
          <div className="service-top-hero">
            <div className="service-top-hero-tag">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    {/*<p></p>*/}
                  </div>
                </div>
              </div>
            </div>
            <div className="service-top-hero-bottom-part">
              <div className="service-top-hero-title">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h1>{t("Program lojalnościowy")}</h1>
                      {/* <p className="ybadge2">Wash Mist GRATIS!</p> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="service-top-hero-black-bottom">
                <div className="container dontshowmeonmobile">
                  <div className="row">
                    <div className="col-lg-6 col-sm-8">
                      <p className="service-top-hero-black-bottom-subtitle">{t("Korzystasz z usług naszej myjni, detailingu lub serwisu? Zbieraj punkty i wymieniaj je na nagrody.")}</p>
                      <p className="service-top-hero-black-bottom-price"></p>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                      {resBut}
                    </div>
                  </div>
                </div>
                <div className="container showmeonlyonmobile">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="service-top-mob-left">
                        <p className="service-top-hero-black-bottom-subtitle">{t("Korzystasz z usług naszej myjni, detailingu lub serwisu? Zbieraj punkty i wymieniaj je na nagrody.")}</p>
                        <p className="service-top-hero-black-bottom-price"></p>
                      </div>
                      <div className="service-top-mob-right">
                        {resBut}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </Parallax>
          <div className="service-main-content">
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                    <p className="service-desc-par"><b>{t("Wystarczy:")}</b></p>
                    <ol className="service-desc-par">
                       <li><p className="service-desc-par">{t("Założyć konto podając adres e-mail i hasło;")}</p></li>
                       <li><p className="service-desc-par">{t("Po zalogowaniu, wypełnić dane: imie, nazwisko, nr tel;")}</p></li>
                       <li><p className="service-desc-par">{t("Punkty są przyznawane za usługi myjni i detailingu oraz za usługi serwisowe;")}</p></li>
                       <li><p className="service-desc-par">{t("Punkty zdobywasz wg wzoru: 1 zł wydane na usługi = 1 pkt w programie;")}</p></li>
                       <li><p className="service-desc-par">{t("Dodatkowe punkty możesz zdobyć za polecenie programu znajomym. Każdy zarejestrowany znajomy = 50 pkt;")}</p></li>
                       <li><p className="service-desc-par">{t("Zbieraj punkty i wymieniaj na nagrody. Do zdobycia produkty Soft99 oraz usługi w Soft99 Garage.")}</p></li>
                    </ol>
                </div>
                <div className="col-lg-5">
                  {mediaBox}
                </div>              
              </div>
              <div className="row services-packages-row plloginbox">
                <p className="lsbut lsbutreg"><a href={localizedLink("https://app.loyaltystarter.io/member/ffc201e8-38c7-40d7-851c-d505287e72b9/sign-up")} target="_blank">{t("Zarejestruj się")}</a></p>
                <p className="lsmidle">{t("lub")}</p>
                <p className="lsbut lsbutlog"><a href={localizedLink("https://app.loyaltystarter.io/member/ffc201e8-38c7-40d7-851c-d505287e72b9/login")} target="_blank">{t("Zaloguj się")}</a></p>
              </div>
            </div>
          </div>
          <Footer />
        </section>
    )
};

export default Loyalty;